var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isFunction } from 'angular';
import { CaptchaController } from '../controllers/captcha-controller';
var EmailShareController = (function (_super) {
    __extends(EmailShareController, _super);
    function EmailShareController($http, $q, $location, emailShareConfiguration, vcRecaptchaService) {
        var _this = _super.call(this, vcRecaptchaService, $q) || this;
        _this.$http = $http;
        _this.$location = $location;
        _this.emailShareConfiguration = emailShareConfiguration;
        _this.defaultSegmetType = 'default';
        _this.showReCaptcha = false;
        _this.showSimpleMath = false;
        return _this;
    }
    EmailShareController.prototype.$onInit = function () {
        var _this = this;
        this.loading = true;
        this.emailShareConfiguration
            .get()
            .then(function (configuration) {
            _this.configuration = configuration;
            _this.translation = configuration.translations[_this.defaultSegmetType];
            _this.reCaptchaPublicKey = configuration.reCaptchaPublicKey || '';
            _super.prototype.checkGoogleAccessibility.call(_this).then(function () {
                _this.showReCaptcha = true;
            }, function () {
                _this.initSimpleMath();
                _this.showSimpleMath = true;
            });
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    EmailShareController.prototype.finishLoading = function () {
        this.contentLoaded = true;
    };
    EmailShareController.prototype.reCaptchaSetResponse = function (response) {
        _super.prototype.reCaptchaSetResponse.call(this, response);
        this.sendData();
    };
    EmailShareController.prototype.initSimpleMath = function (callback) {
        var _this = this;
        this.$http.get(this.configuration.simpleMathQuestionEndpoint).then(function (response) {
            _this.simpleMathId = response.data.id || '';
            _this.simpleMathQuestion = response.data.question || '';
            _this.simpleMathUserResult = response.data.userResult || null;
            _this.showSimpleMath = true;
            if (isFunction(callback)) {
                callback();
            }
        });
    };
    EmailShareController.prototype.submitForm = function (submitEvent) {
        submitEvent.preventDefault();
        this.showReCaptcha ? this.vcRecaptchaService.execute(this.reCaptchaWidgetId) : this.sendData();
    };
    EmailShareController.prototype.sendData = function () {
        var _this = this;
        var captchaModel = _super.prototype.getCaptchaModel.call(this);
        var submitData = {
            body: this.body || this.$location.absUrl(),
            captchaModel: captchaModel,
            from: this.from,
            name: this.name,
            to: this.to,
        };
        this.loading = true;
        this.$http
            .post(this.configuration.emailShareEndpoint, JSON.stringify(submitData))
            .then(function (response) {
            if (response.data.statusCode === 400) {
                if (response.data.message !== 'SimpleMath') {
                    _this.hideForm = true;
                    _this.showError = true;
                    return;
                }
                if (!_this.showSimpleMath) {
                    _this.vcRecaptchaService.reload(_this.reCaptchaWidgetId);
                    return;
                }
                _this.initSimpleMath(function () {
                    _this.showSimpleMathError = true;
                });
            }
            else {
                _this.hideForm = true;
                _this.showSuccess = true;
            }
        }, function () {
            _this.hideForm = true;
            _this.showError = true;
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    EmailShareController.$inject = ['$http', '$q', '$location', 'emailShareConfiguration', 'vcRecaptchaService'];
    return EmailShareController;
}(CaptchaController));
export var EmailShareComponent = {
    bindings: {
        contentLoaded: '=',
    },
    controller: EmailShareController,
    template: "<div ng-include=\"'compatibilityguide/ng-templates/feature/forms/emailshare'\" onload=\"$ctrl.finishLoading()\"></div>",
};
